__turbopack_context__.v({
  "base": "CodeExample-module__uwsrXG__base",
  "baseinner": "CodeExample-module__uwsrXG__baseinner",
  "codeExample": "CodeExample-module__uwsrXG__codeExample",
  "codeHeader": "CodeExample-module__uwsrXG__codeHeader",
  "comment": "CodeExample-module__uwsrXG__comment",
  "content": "CodeExample-module__uwsrXG__content",
  "inside": "CodeExample-module__uwsrXG__inside",
  "title": "CodeExample-module__uwsrXG__title",
  "wrapper": "CodeExample-module__uwsrXG__wrapper",
});
